import { Table, Dropdown, Flex, Input } from "antd";
import styled from "styled-components";
import { IAccount } from "../../../../interfaces/store/user-interfaces";
import { ReactComponent as ThreeDotsVertical } from "../../../../assets/icons/ThreeDotsVertical.svg";
import { ReactComponent as FacebookIcon } from "../../../../assets/icons/FacebookIcon.svg";
import { ReactComponent as GoogleIcon } from "../../../../assets/icons/GoogleIcon.svg";
import { ReactComponent as AppleIcon } from "../../../../assets/icons/AppleIcon.svg";
import { ReactComponent as MailIcon } from "../../../../assets/icons/MailIcon.svg";

export const StyledUserTable = styled(Table<IAccount>).attrs({
    locale: { emptyText: ''}
})`
    border-radius: 0.5rem;
    margin-top: 2.5rem;
    box-shadow: 0px 0.5px 1px rgba(0, 0, 0, 0.1),  0px 2px 4px rgba(0, 0, 0, 0.1); 

    .ant-table-thead > tr > th {
        border-bottom: none; /* Removes the border between the header and the content */
        font-size: 12px;
        font-weight: 400;
        font-color: #808080;
        line-height: 24px;
        color: #808080;
        height: 44px;
    }
    .ant-table-column-sorter-up.active,
    .ant-table-column-sorter-down.active {
      color: inherit;
    }

    .ant-table-content::-webkit-scrollbar {
        width: 1px;
    }

    .ant-table-content::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    .ant-table-content::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
    }

    .ant-table-tbody > tr > td:last-child,
    .ant-table-thead > tr > th:last-child {
      width: 6rem; /* Change this to your desired width */
    }

    .cursor-pointer {
        cursor: pointer;
    }
`;

export const UserActionsButton = styled(Dropdown)`
      width: 20px;
      height: 20px;
      cursor: pointer;
`;

export const StyledThreeDotsVertical = styled(ThreeDotsVertical)`
    width: 20px;
    height: 20px;
`;

export const StyledFacebookIcon = styled(FacebookIcon)`
    width: 18px;
    height: 18px;
`;

export const StyledGoogleIcon = styled(GoogleIcon)`
    width: 18px;
    height: 18px;
`;

export const StyledMailIcon = styled(MailIcon)`
    width: 18px;
    height: 18px;
`;

export const StyledAppleIcon = styled(AppleIcon)`
    width: 18px;
    height: 18px;
`;

export const StyledFlex = styled(Flex)`
    gap: 8px;
    align-items: center;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    color: #313131;
`;

export const StyledDropdown = styled(Dropdown)`
  direction: rtl;
`;
